import PropTypes from 'prop-types'
import React from 'react'
import { Redirect, useLocation } from 'react-router'
import { ROUTES } from 'constants/routes'
import { ROUTE_ACCESS } from 'utils/routeAccess'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useAuthState } from 'modules/Auth/hooks/useAuthState'
import { hasStoredAuthSession } from 'utils/authSessionStorage'

const RouteGuard = ({ route, children }) => {
  const location = useLocation()
  const pathGen = useGeneratePathI18n()
  const { isAuthenticated, isSessionPending } = useAuthState()

  const isResolvingSession =
    !isAuthenticated && (isSessionPending || hasStoredAuthSession())

  if (route.access === ROUTE_ACCESS.PRIVATE) {
    if (!isAuthenticated) {
      if (isResolvingSession) {
        return null
      }

      return (
        <Redirect
          to={{
            pathname: pathGen(ROUTES.AUTH_LOGIN),
            state: { from: location },
          }}
        />
      )
    }
  }

  return children
}

RouteGuard.propTypes = {
  route: PropTypes.shape({
    access: PropTypes.string,
  }).isRequired,
  children: PropTypes.node,
}

export default RouteGuard
